import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IMAGES } from '../layout/theme';
import MainBanner from '../components/MainBanner';
import { apiClient } from '../services/api';

const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        const formData = new FormData(e.currentTarget);
        const email = formData.get('email') as string;

        setIsLoading(true);
        try {
            await apiClient.post('/password/forgot', { email });
            setSubmitted(true);
        } catch {
            setError('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="main-banner" id="main-forgot" style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            paddingTop: '120px',
            paddingBottom: '60px',
            position: 'relative'
        }}>
            <MainBanner />
            <Link
                to="/login"
                style={{
                    position: 'absolute',
                    top: '30px',
                    left: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '12px 24px',
                    backgroundColor: '#ffffff',
                    color: '#2c3d4f',
                    textDecoration: 'none',
                    borderRadius: '4px',
                    fontSize: '16px',
                    fontWeight: '500',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s',
                    zIndex: 10
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#d89d37';
                    e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#2c3d4f';
                }}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                Back to Login
            </Link>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8">
                        <div className="login-box" style={{
                            backgroundColor: '#ffffff',
                            padding: '40px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
                        }}>
                            <div className="text-center mb-4">
                                <img src={IMAGES.logoWithColor} alt="Pure Key Homes" style={{ maxWidth: '200px', marginBottom: '20px' }} />
                                <h3 className="h3-title">Forgot Password</h3>
                                <p style={{ color: '#666' }}>
                                    Enter your email and we'll send you a reset link
                                </p>
                            </div>

                            {submitted ? (
                                <div style={{
                                    backgroundColor: '#f0fdf4',
                                    border: '1px solid #bbf7d0',
                                    color: '#16a34a',
                                    padding: '16px',
                                    borderRadius: '4px',
                                    textAlign: 'center',
                                    fontSize: '15px'
                                }}>
                                    <p style={{ marginBottom: '8px', fontWeight: '600' }}>Check your inbox!</p>
                                    <p style={{ margin: 0 }}>
                                        If that email is registered, you'll receive a password reset link shortly.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    {error && (
                                        <div style={{
                                            backgroundColor: '#fef2f2',
                                            border: '1px solid #fecaca',
                                            color: '#dc2626',
                                            padding: '12px 16px',
                                            borderRadius: '4px',
                                            marginBottom: '20px',
                                            fontSize: '14px'
                                        }}>
                                            {error}
                                        </div>
                                    )}
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-box" style={{ marginBottom: '20px' }}>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-input"
                                                placeholder="Email Address"
                                                required
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            className="sec-btn"
                                            disabled={isLoading}
                                            style={{
                                                width: '100%',
                                                padding: '15px',
                                                opacity: isLoading ? 0.7 : 1,
                                                cursor: isLoading ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <span>{isLoading ? 'Sending...' : 'Send Reset Link'}</span>
                                        </button>
                                    </form>
                                </>
                            )}

                            <div className="text-center mt-4">
                                <p style={{ color: '#666', fontSize: '14px' }}>
                                    Remembered it? <Link to="/login" style={{ color: '#d89d37', textDecoration: 'none' }}>Sign In</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ForgotPassword;
